// PatientsForm.js
import React, { useState, useEffect } from "react";
import { API_IP } from "../../env";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button"; // Import Button

// Accept 'show' and 'onHide' props
function PatientsForm({ show, onHide, accountID, username }) {
  const [patientLists, setPatientLists] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // --- NEW Pagination State ---
  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 1,
    totalPages: 1,
  });

  async function axiosReqConfig(url, method, data) {
    const bearerToken = localStorage.getItem("@uphealth_login_token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: data,
    };
    return await axios(reqConfig);
  }

  // --- MODIFIED: getAllPatients now accepts a page number ---
  async function getAllPatients(page = 1) {
    if (!accountID) return;
    setIsLoading(true);
    try {
      // Pass page to the API, limit=10 is now the default on the server
      const { data } = await axiosReqConfig(
        `${API_IP}/api/admin/users/${accountID}?page=${page}`,
        "get",
        []
      );

      // Handle new paginated response
      if (data && data.pagination) {
        setPatientLists(data.data);
        setPaginationInfo(data.pagination);
      } else {
        // Fallback for old API
        setPatientLists(data);
      }
    } catch (err) {
      console.error("Failed to fetch patients", err);
    }
    setIsLoading(false);
  }

  // Fetch data only when the modal is shown
  useEffect(() => {
    if (show) {
      getAllPatients(1); // Reset to page 1 every time modal opens
    }
  }, [show, accountID]); // Re-run if 'show' or 'accountID' changes

  // --- NEW Pagination Handlers ---
  const handleNextPage = () => {
    if (paginationInfo.currentPage < paginationInfo.totalPages) {
      getAllPatients(paginationInfo.currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (paginationInfo.currentPage > 1) {
      getAllPatients(paginationInfo.currentPage - 1);
    }
  };

  function Item({ item }) {
    return (
      <tr>
        <td>
          {item.first_name} {item.last_name}
        </td>
        <td>{item.relationship_name}</td>
        <td>
          {item.is_removed ? (
            <Badge bg="danger">Removed</Badge>
          ) : (
            <Badge bg="success">Active</Badge>
          )}
        </td>
        <td>{item.birth_year}</td>
      </tr>
    );
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Patients Of: {username}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <p>Loading patients...</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead className="table-dark">
              <tr>
                <th>Full Name</th>
                <th>Relationship</th>
                <th>Status</th>
                <th>Birth Year</th>
              </tr>
            </thead>
            <tbody>
              {patientLists.length > 0 ? (
                patientLists.map((item, index) => (
                  <Item key={item.patient_id || index} item={item} />
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No patients found for this user.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      {/* --- NEW Modal Footer with Pagination --- */}
      <Modal.Footer className="justify-content-between">
        <div>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handlePreviousPage}
            disabled={paginationInfo.currentPage <= 1 || isLoading}
          >
            &larr; Previous
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            className="ms-2"
            onClick={handleNextPage}
            disabled={
              paginationInfo.currentPage >= paginationInfo.totalPages ||
              isLoading
            }
          >
            Next &rarr;
          </Button>
        </div>
        <span className="text-muted small">
          Page {paginationInfo.currentPage} of {paginationInfo.totalPages}
        </span>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PatientsForm;
